import { Text } from '@user-portal/wikr-components';
import { useTranslation } from 'react-i18next';

import { notifySuccess } from 'store/notifications/actions';

import { sendAnalyticAccessCodeCopied, sendAnalyticAccessCodeError } from 'services/Analytics/trackers/accessCode';

import { useDispatch } from 'hooks';
import useModals from 'modals/hooks';
import { ModalName } from 'modals/types';

import Skeleton from 'components/Skeleton';

import * as S from './styled';

const CopyCodeMobile = ({ accessCode, isLoading }: { accessCode?: string; isLoading: boolean }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { openModal } = useModals();
    const formattedAccessCode = accessCode && accessCode.split('').map((ch, i) => <span key={i}>{ch}</span>);

    const handleCopy = () => {
        if (accessCode) {
            if (navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard
                    .writeText(accessCode)
                    .then(() => {
                        dispatch(notifySuccess({ message: 'main.step.copyCode.mobile.success.text' }));
                        sendAnalyticAccessCodeCopied();
                    })
                    .catch(() => {
                        fallbackCopy(accessCode);
                    });
            } else {
                fallbackCopy(accessCode);
            }
        }
    };

    const fallbackCopy = (text: string) => {
        const textarea = document.createElement('textarea');

        textarea.value = text;
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        textarea.focus();
        textarea.select();
        const result = document.execCommand('copy');

        if (result) {
            dispatch(notifySuccess({ message: 'main.step.copyCode.mobile.success.text' }));
            sendAnalyticAccessCodeCopied();
        } else {
            openModal(ModalName.CopyCodeErrorModal);
            sendAnalyticAccessCodeError('Clipboard copy failed');
        }
        document.body.removeChild(textarea);
    };

    return (
        <S.LogInMobileWrapper>
            <Text type="large-text" bold mb={16} center>
                {t('main.step.copyCode.mobile.title')}
            </Text>
            <Text type="caption" bold mb={4} center color="text-secondary-subdued">
                {t('main.step.copyCode.mobile.uniqueCode')}
            </Text>
            {isLoading ? (
                <Skeleton height={58} mb={4} />
            ) : (
                <S.AccessCode bold center dataLocator="accessCode">
                    {formattedAccessCode}
                </S.AccessCode>
            )}
            <Text type="caption" bold mb={20} center color="text-secondary-subdued">
                {t('main.step.copyCode.codeValidity')}
            </Text>
            <S.LogInMobileBtn onClick={handleCopy} size="small" dataLocator="copyAccessCodeBtn" disabled={isLoading}>
                {t('main.step.copyCode.mobile.copyTheCode')}
            </S.LogInMobileBtn>
        </S.LogInMobileWrapper>
    );
};

export default CopyCodeMobile;
